// src/Dashboard/pages/user/Messaging/utils/messagingUtils.js

import { toAbsoluteUserPhotoUrl } from "../../../../../services/userPhotoServices";

export const MESSAGE_SUBJECT_OPTIONS = [
  "Adhésion",
  "Dossier d'inscription",
  "Règlement",
  "Informations cours",
  "Absence",
  "Inscription compétition",
  "Perte d'objet",
  "Autre (saisir)",
];

export const CHAT_BG_THEMES = [
  {
    id: "slate",
    name: "Neutre",
    area: "bg-slate-100/70 dark:bg-slate-950/40",
  },
  {
    id: "sky",
    name: "Bleu pastel",
    area: "bg-sky-100/70 dark:bg-slate-950/40",
  },
  {
    id: "emerald",
    name: "Vert pastel",
    area: "bg-emerald-100/70 dark:bg-slate-950/40",
  },
  {
    id: "rose",
    name: "Rose pastel",
    area: "bg-rose-100/70 dark:bg-slate-950/40",
  },
  {
    id: "violet",
    name: "Violet pastel",
    area: "bg-violet-100/70 dark:bg-slate-950/40",
  },
  {
    id: "amber",
    name: "Pêche pastel",
    area: "bg-amber-100/70 dark:bg-slate-950/40",
  },
];

export const stripHtml = (html = "") => {
  if (typeof document === "undefined") {
    return String(html || "")
      .replace(/<[^>]*>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html || "";
  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
};

export const sanitizeLight = (html = "") => {
  try {
    const doc = new DOMParser().parseFromString(String(html || ""), "text/html");

    doc.querySelectorAll("script").forEach((node) => node.remove());

    doc.querySelectorAll("a").forEach((anchor) => {
      const href = anchor.getAttribute("href") || "";

      if (/^\s*javascript:/i.test(href)) {
        anchor.removeAttribute("href");
      }

      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return doc.body.innerHTML || "";
  } catch {
    return "";
  }
};

export const formatMessageDate = (value) => {
  if (!value) return "—";

  try {
    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    }).format(new Date(value));
  } catch {
    return "—";
  }
};

export const formatMessageTime = (value) => {
  if (!value) return "—";

  try {
    return new Intl.DateTimeFormat("fr-FR", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(new Date(value));
  } catch {
    return "—";
  }
};

export const getMessageDateValue = (message) =>
  message?.created_at || message?.createdAt || message?.updated_at || message?.updatedAt;

export const isUnreadMessage = (message) => {
  return (
    !message?.read_message ||
    message.read_message === 0 ||
    message.read_message === "0"
  );
};

export const getUserFullName = (user) => {
  return `${user?.prenom || ""} ${user?.nom || ""}`.trim() || "Utilisateur";
};

export const getUserAvatar = (user) => {
  return toAbsoluteUserPhotoUrl(
    user?.photoURL || user?.photo_url || "/img/user_avatar.jpg"
  );
};

export const roleMeta = (roleId) => {
  if (Number(roleId) === 1) {
    return {
      label: "Administrateur",
      className:
        "bg-red-50 text-red-700 ring-red-200 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20",
    };
  }

  if (Number(roleId) === 3) {
    return {
      label: "Enseignant",
      className:
        "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
    };
  }

  return {
    label: "Utilisateur",
    className:
      "bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:ring-slate-700",
  };
};

export const normalizeText = (value = "") =>
  String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const sortByNewest = (list = []) => {
  return [...list].sort(
    (a, b) =>
      new Date(getMessageDateValue(b) || 0).getTime() -
      new Date(getMessageDateValue(a) || 0).getTime()
  );
};